import { render, staticRenderFns } from "./vRecipeDetails.vue?vue&type=template&id=6067be40&scoped=true"
import script from "./vRecipeDetails.vue?vue&type=script&lang=ts"
export * from "./vRecipeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6067be40",
  null
  
)

export default component.exports